export default __webpack_public_path__ + "static/media/cif-hr.02928120.svg";